<template>
  <b-modal
    id="modal-back-to-result"
    class="mc-modal"
    :title="$t('routeOptimization.alert.cancelEditTitle')"
    header-bg-variant="primary"
    size="md"
    centered
  >
    <p
      class="mt-2 p-0"
      v-html="
        $t('routeOptimization.alert.cancelEditMessage', {
          data: roNumber,
        })
      "
    ></p>
    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.back')"
        @click="$bvModal.hide('modal-back-to-result')"
      />
      <McButton
        variant="primary"
        type="submit"
        :text="$t('global.alert.text.cancel')"
        @click="handleBackToResult"
      />
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    roNumber: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleBackToResult() {
      this.$router.push({
        name: 'Route Optimization Detail',
        params: { id: this.$route.params.id },
      })
    },
  },
}
</script>
